module.exports = __webpack_public_path__ + "nc_static/media/refresh-cards.c39ff5e3.svg";